import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';

import { absoluteRoutePaths } from 'app/core/routing';
import { selectIsAuthenticated } from 'app/state/user-session/user-session.selectors';

export const authorizationGuardFn: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);
    return store.pipe(
        select(selectIsAuthenticated),
        map((isAuthenticated) => isAuthenticated || router.parseUrl(absoluteRoutePaths.signin)),
    );
};
